import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { CommonCode, ICommonCode } from '../common-code/CommonCode';

/**
 * # User
 *
 * User을 설명하세요.
 */
export const User = types
  .model('User')
  // --------------------------------------------------------------------------
  .props({
    userSid: types.maybeNull(types.optional(types.number, 0)),
    loginId: types.maybeNull(types.optional(types.string, '')),
    pwd: types.maybeNull(types.optional(types.string, '')),
    userNm: types.maybeNull(types.optional(types.string, '')),
    email: types.maybeNull(types.optional(types.string, '')),
    authType: types.maybeNull(types.optional(CommonCode, {})),
    acntSttsCd: types.maybeNull(types.optional(CommonCode, {})),
    acntSttsDt: types.maybeNull(types.optional(types.string, "")),
    loginFailCnt: types.maybeNull(types.optional(types.number, 0)),
    pwdUpdDt: types.maybeNull(types.optional(types.string, "")),
    regDt: types.maybeNull(types.optional(types.string, "")),
    regId: types.maybeNull(types.optional(types.number, 0)),
    updDt: types.maybeNull(types.optional(types.string, "")),
    updId: types.maybeNull(types.optional(types.number, 0)),
    newPwd: types.maybeNull(types.optional(types.string, '')),
    confirmPwd: types.maybeNull(types.optional(types.string, '')),
    agrTermsSids: types.maybeNull(types.optional(types.string, '')),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model user --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IUser;
      (Object.keys(newProps) as TUserKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TUser = Instance<typeof User>;
type TUserSnapshot = SnapshotOut<typeof User>;

export interface IUser extends TUser { }
export type TUserKeys = keyof TUserSnapshot & string;
export interface IUserSnapshot extends TUserSnapshot { }
export const createUser = () => types.optional(User, {} as TUser);
